export function PropertyGridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="property-grid" aria-hidden="true">
      {Array.from({ length: count }).map((_, index) => (
        <div className="property-card skeleton-card" key={index}>
          <div className="skeleton-media shimmer" />
          <div className="skeleton-body">
            <span className="skeleton-line shimmer skeleton-short" />
            <span className="skeleton-line shimmer" />
            <span className="skeleton-line shimmer skeleton-medium" />
            <span className="skeleton-line shimmer skeleton-price" />
          </div>
        </div>
      ))}
    </div>
  );
}
